export default function CurrentPage({ page }) {
  return (
    <li key={page}>
      <p
        className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-gray-200 border border-gray-300"
      >
        {page}
      </p>
    </li>
  );
}
